import React, { useEffect, useState } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import { chapters } from '../data/chapters';
import { researchProjects } from '../data/projects';
import ChapterHeader from '../components/ChapterHeader';
import ChapterFooter from '../components/ContactFooter';
import Footer from '../components/Footer';
import ChapterDetails from '../components/sections/ChapterDetails';
import ChapterTeam from '../components/sections/ChapterTeam';
import ChapterResearch from '../components/sections/ChapterResearch';
import ChapterContact from '../components/sections/ChapterContact';
import ResearchDetailCard from '../components/ResearchDetailCard';

const ChapterPage = () => {
  const { slug } = useParams();
  const [searchParams] = useSearchParams();
  const sectionFromUrl = searchParams.get('section') || 'details';
  const researchSlug = searchParams.get('project');

  const chapter = chapters.find(c => c.slug === slug);

  const [selectedProject, setSelectedProject] = useState(null);

  useEffect(() => {
    if (researchSlug && chapter) {
      const project = researchProjects.find(p => p.slug === researchSlug && p.chapter === chapter.name);
      setSelectedProject(project);
    } else {
      setSelectedProject(null);
    }
  }, [researchSlug, chapter]);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [sectionFromUrl, researchSlug]);

  if (!chapter) {
    return (
      <div style={{ padding: '6rem', color: '#fff', textAlign: 'center' }}>
        <h1>Chapter not found</h1>
      </div>
    );
  }

  const actions = [
    { id: 'details', label: 'Details' },
    { id: 'projects', label: 'Projects' },
    { id: 'leadership', label: 'Leadership' },
    { id: 'contact', label: 'Contact' },
  ];

  const hasSponsor = selectedProject?.orgs?.some(
    org => org.name === 'Sponsor' && org.image && org.image !== '/question-mark.webp'
  );

  return (
    <div style={{ backgroundColor: '#000', color: '#fff', minHeight: '100vh' }}>
      <ChapterHeader
        name={chapter.name}
        logo={chapter.logo}
        description={chapter.description}
        actions={actions}
        currentSection={sectionFromUrl}
        chapterSlug={slug}
      />

      <main style={{ padding: '3rem 2rem', maxWidth: '1200px', margin: '0 auto' }}>
        {sectionFromUrl === 'details' && (
          <ChapterDetails chapter={chapter} discordUrl={chapter.discord} instagramUrl={chapter.instagram} />
        )}

        {sectionFromUrl === 'projects' && !selectedProject && (
          <ChapterResearch chapterName={chapter.name} />
        )}

        {sectionFromUrl === 'projects' && selectedProject && (
          <ResearchDetailCard
            {...selectedProject}
            onSponsor={!hasSponsor ? () => window.open(`https://donate.doquantum.org/${researchSlug}`, '_blank') : undefined}
          />
        )}

        {sectionFromUrl === 'leadership' && (
          <ChapterTeam team={chapter.team} />
        )}

        {sectionFromUrl === 'contact' && (
          <ChapterContact chapterName={chapter.name} />
        )}
      </main>

      {sectionFromUrl === 'contact' ? <ChapterFooter /> : <Footer />}
    </div>
  );
};

export default ChapterPage;